<div *ngIf="modules.length">
  <div class="settings-management-header settings-header-license"
       translate="TABLE.LICENSE_MGMT"></div>
  <div class="pop-display-flex"
       *ngIf="resources; else loadingTemplate">
    <div>
      <div class="license-search-user">
        <label translate="OPTIONS.LICENSE_ADDUSER"></label>
        <pop-user-picker (selectedUsersChange)="addUser($event)"></pop-user-picker>
      </div>
      <div class="licensedusers-table-container">
        <p-table [value]="resources"
                 [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th translate="OPTIONS.USERS"></th>
              <th *ngFor="let module of modules"
                  class="module-cell">
                {{ module.name }}
                <span *ngIf="userCountPerModule[module.moduleId]">
                  ({{ userCountPerModule[module.moduleId] }} /
                  {{ module.number }})
                </span>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body"
                       let-resource>
            <tr>
              <td>
                {{ resource.email }}
              </td>
              <td *ngFor="let module of modules"
                  class="module-cell">
                <p-checkbox #checkbox
                            id="{{ resource.email + '_' + module.moduleId }}"
                            [binary]="true"
                            (onChange)="onCheckboxChange(resource.email, module.moduleId, checkbox, $event)"
                            [ngModel]="resource | isUserLicensedInModule: module.moduleId">
                </p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="settings-description"
         translate="OPTIONS.LICENSE_MGMT_DESC"></div>
  </div>
</div>
<ng-template #loadingTemplate>
  <pop-loading [isInline]="true">
  </pop-loading>
</ng-template>
